<div class="leader-baord-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="leader-board-details w-100">
                    <div class="header-div text-center">
                        <h4>Contest Details</h4>
                    </div>
                    <div class="details-body">
                        <div class="media">
                            <div class="media-left">
                                <h4>Selected Player</h4>
                                <div class="player-details">
                                    <div class="img">
                                        <img src="assets/img/players/Leander-Paes-3.jpg" alt="">
                                    </div>
                                    <div class="player-name wright">
                                        <h5>Leander Paes</h5>

                                        <span class="TPL-points right"> <i class='bx bxs-check-circle' ></i> <i class='bx bxs-x-circle' ></i> 1 TPL Pts</span>
                                    </div>
                                </div>
                            </div>
                            <div class="media-body">
                                <div class="selected-quations">
                                    <h4>Questions:</h4>
                                    <div class="question-list">
                                        <ul>
                                            <li class="selected-qutions">
                                                Play on Total Points Won | <span class="TPL-points right"> <i class='bx bxs-check-circle' ></i> <i class='bx bxs-x-circle' ></i> 1 TPL Pts</span> 
                                            </li>
                                            <li>
                                                Play on Total Points Won | <span class="TPL-points right"> <i class='bx bxs-check-circle' ></i> <i class='bx bxs-x-circle' ></i> 1 TPL Pts</span> 
                                            </li>
                                            <li class="selected-qutions">
                                                Play on Total Points Won | <span class="TPL-points wrong"><i class='bx bxs-check-circle' ></i>  <i class='bx bxs-x-circle' ></i> 1 TPL Pts</span> 
                                            </li>
                                            <li class="selected-qutions">
                                                
                                                Play on Total Points Won | <span class="TPL-points right"> <i class='bx bxs-check-circle' ></i> <i class='bx bxs-x-circle' ></i>  1 TPL Pts</span> 
                                            </li>
                                            <li>
                                                Play on Total Points Won | <span class="TPL-points wrong"> <i class='bx bxs-check-circle' ></i> <i class='bx bxs-x-circle' ></i> 1 TPL Pts</span> 
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="media-right">
                                <h4>Rewards:</h4>
                                <div class="total-points-div">
                                    <ul>
                                        <li>
                                            <span class="total-reward">
                                                Total TPL Points:
                                                <span class="Points">250 pt</span> 
                                            </span>
                                            
                                        </li>
                                        <li>
                                            <span class="total-reward">
                                                Wining Amount:
                                                <span class="Points">50000 TPL Coins</span> 
                                            </span> 
                                         
                                        </li>
                                    </ul>
                                  
                                </div>

                                <div class="rank-position">
                                    Rank: 5th
                                </div>
                            </div>
                        </div>

                    </div>
                  
                </div>
            </div>
        </div>
    </div>
</div>
<div id="joinMsg" style="display: none;">
    <h1>Please join contest.</h1>
</div>